import { Box, CssBaseline } from "@mui/material";
import { PropsWithChildren } from "react";

function Layout({ children }: PropsWithChildren<{}>) {
	return (
		<Box sx={{ display: "flex", minHeight: "100vh", overflow: "hidden" }}>
			<CssBaseline />
			{children}
		</Box>
	);
}

export default Layout;
